export default __webpack_public_path__ + "static/finastra-9f8a03dff6f04322e468ad09a1e5f6d7.png";